import { Dialog, DialogPassThroughOptions } from 'primereact/dialog';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import {
  currentModalDataSelector,
  currentModalSelector,
  currentModalVisibleSelector,
} from 'src/redesign/features/Modals/store/selector';
import { CONNECTED_MODALS_COMPONENTS } from 'src/redesign/features/Modals/store/constants';
import { closeCurrentModalAction } from 'src/redesign/features/Modals/store/reducer';
import { useMemo } from 'react';
import S from './Modals.module.scss';

const pt: DialogPassThroughOptions = {
  headerTitle: {
    className: S.headerTitle,
  },
  mask: {
    style: {
      zIndex: '99999 !important',
    },
  },
};

export const Modals = () => {
  const currentModal = useAppSelector(currentModalSelector);
  const currentModalVisible = useAppSelector(currentModalVisibleSelector);
  const currentModalData = useAppSelector(currentModalDataSelector);
  const dispatch = useAppDispatch();
  const CurrentModalComponent = CONNECTED_MODALS_COMPONENTS[currentModal];

  const header = useMemo(() => {
    if (!currentModalData) return null;
    if (!Object.keys(currentModalData).includes('title')) return null;
    return currentModalData.title;
  }, [currentModalData]);

  const element = useMemo(() => {
    if (!CurrentModalComponent) return null;
    const isObject =
      currentModalData && !Array.isArray(currentModalData) && typeof currentModalData === 'object';

    if (isObject) {
      return <CurrentModalComponent {...currentModalData} />;
    }
    return <CurrentModalComponent />;
  }, [CurrentModalComponent, currentModalData]);

  return (
    <Dialog
      header={header}
      pt={pt}
      visible={currentModalVisible}
      onHide={() => dispatch(closeCurrentModalAction())}
      draggable={false}
      resizable={false}
    >
      {element}
    </Dialog>
  );
};
